import toast from "@lonelyplanet/dotcom-core/dist/reducers/toast";
import { combineReducers } from "redux";
import bookmarks from "./bookmarks";
import nearbyPois from "./nearbyPois";
import user from "./user";
var rootReducer = combineReducers({
    bookmarks: bookmarks,
    nearbyPois: nearbyPois,
    toast: toast,
    user: user,
});
export default rootReducer;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/reducers/index.ts
// module id = dAD3
// module chunks = 2